/**
 * Tracks where the user started the "Dobít kredit" flow so we can return them
 * there both when they hit the header back arrow and after the payment gateway
 * redirects back. SessionStorage survives the external payment gateway redirect
 * (within the same tab) where react-router navigation state would not.
 */

const STORAGE_KEY = 'credit-top-up-return-path';

export function setReturnPath(path: string): void {
    try {
        sessionStorage.setItem(STORAGE_KEY, path);
    } catch (error) {
        console.error('Failed to save credit top-up return path:', error);
    }
}

export function getReturnPath(): string | null {
    try {
        return sessionStorage.getItem(STORAGE_KEY);
    } catch (error) {
        console.error('Failed to read credit top-up return path:', error);
        return null;
    }
}

export function clearReturnPath(): void {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        console.error('Failed to clear credit top-up return path:', error);
    }
}
